import React from "react";
import classNames from "classnames";
import styles from "./fix-image.module.scss";
import FixImagePlaceholder from "./fix-image-placeholder";
import { LayoutStyleTypes } from "@/util-react/layout";

export interface FixImageProps {
  src?: string;
  alt?: string;
  type?: LayoutStyleTypes.TYPE_LG | LayoutStyleTypes.TYPE_SM;
  className?: string;
  aspect?: number;
}

export const FixImage: React.FC<FixImageProps> = ({ src, alt = "", type = LayoutStyleTypes.TYPE_LG, className, aspect = 1 }) => {
  return (
    <div className={classNames(styles.root, styles.container, className)} style={{ "--size": undefined, "--aspect": aspect } as React.CSSProperties}>
      {src && <img className={classNames(styles.image, styles.visible)} src={src} alt={alt} fetchPriority={"high"} loading={"eager"} decoding={"async"} />}
      {!src && <FixImagePlaceholder type={type} className={styles.placeholder} />}
    </div>
  );
};

export default FixImage;
